import { SxProps } from '@mui/material';
import { red2, white } from 'app/components/ThemeProvider/colors';

export const paperProps: SxProps = { borderRadius: '8px', width: '517px', maxHeight: 'none' };

export const title: SxProps = {
  fontSize: '26px',
  fontWeight: '600',
};

export const dialogTitle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  p: '24px 24px 0 40px',
};

export const closeBtn: SxProps = {
  padding: '10px',
  minWidth: '36px',
  height: '36px',
  width: '36px',
  borderRadius: '8px',
  alignItems: 'centre',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const dialogActions: SxProps = {
  p: '0 0 40px 40px',
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '12px',
};

export const deleteBtn: SxProps = {
  background: red2,
  color: white,

  '&:hover': {
    background: red2,
  },
};
